export default {
      id: "icon-time-usage",
      viewBox: "0 0 24 24",
      url: "../icon/" + "icons.svg#icon-time-usage",
      toString: function () {
        return this.url;
      }
    }